import { tr } from '@/i18n';
/** 遊戲時間一律用「分鐘」計算；跨日的班別（夜班）分鐘數會超過 1440。 */
export const toMin = (hhmm: string): number => {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
};
const pad = (n: number) => String(n).padStart(2, '0');
export const fmtClock = (min: number): string => {
  const m = Math.floor(min) % 1440;
  return `${pad(Math.floor(m / 60))}:${pad(m % 60)}`;
};
/** 回傳 [開始, 結束]，結束 <= 開始時代表跨日 */
export const shiftRange = (start: string, end: string): [number, number] => {
  const s = toMin(start); let e = toMin(end);
  if (e <= s) e += 1440;
  return [s, e];
};
/** 把某個「時刻」對應到班別時間軸上（例如夜班的 11:00 會是隔天） */
export const onShift = (hhmm: string, shiftStart: number): number => {
  let t = toMin(hhmm);
  while (t < shiftStart) t += 1440;
  return t;
};
export const fmtDuration = (min: number): string => {
  const m = Math.max(0, Math.round(min));
  return m >= 60 ? tr("{0} 小時 {1} 分", Math.floor(m / 60), m % 60) : tr("{0} 分", m);
};
